import Vue from "vue";
import Router from "vue-router";
import Map from "./views/map/Map.vue";
import Admin from "./views/admin/Admin.vue";
import Login from "./views/Login.vue";
import Logout from "./views/Logout.vue";

import store from "@/store/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: {
        name: "login"
      }
    },
    {
      path: "/map",
      name: "map",
      component: Map,
      meta: { requiresAuth: true }
    },
    {
      path: "/map/:portal",
      name: "map",
      component: Map,
      meta: { requiresAuth: true }
    },
    {
      path: "/admin",
      name: "admin",
      component: Admin,
      meta: { admin: true }
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/logout",
      name: "logout",
      component: Logout
    },
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    { path: "*", redirect: "/" }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.admin) && !store.state.user.admin) {
    next({ name: "logout" });
    return;
  }

  if (
    to.matched.some(route => route.meta.requiresAuth) &&
    store.state.view.view.auth !== "guestOnly" &&
    !store.state.user.token
  ) {
    next({ name: "login", query: { redirect: to.fullPath } });
    return;
  }

  // TODO: allow login is guest is supported but not forced
  if (
    to.path === "/login" &&
    (store.state.view.view.auth === "guestOnly" || store.state.user.token)
  ) {
    next({ name: "map" });
    return;
  }

  next();
});

export default router;
